"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const react_rxk_1 = require("react-rxk");
class FieldErrorNoRx extends React.PureComponent {
    render() {
        const props = this.props;
        const error = props.error;
        const text = typeof error == "string" ? error : "";
        return this.props.error ?
            React.createElement("span", { className: "label", style: { whiteSpace: "pre-wrap", color: "#C91717" } }, text) : null;
    }
}
exports.FieldErrorView = react_rxk_1.componentToRx(FieldErrorNoRx);



//////////////////
// WEBPACK FOOTER
// ./~/kea-react/dist/fields/fielderror.js
// module id = 210
// module chunks = 0